function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var InfoIcon = function InfoIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.754 14.112C7.754 14.922 7.754 15.759 7.727 16.569C7.7 17.001 7.592 17.109 7.295 17.109H5.972C5.783 17.109 5.702 17.163 5.702 17.325V17.865C5.702 18.027 5.783 18.081 5.918 18.081C6.215 18.081 7.268 18 8.834 18C9.968 18 11.21 18.081 11.426 18.081C11.615 18.081 11.669 18 11.669 17.811V17.352C11.669 17.19 11.615 17.109 11.399 17.109H10.157C9.86 17.109 9.779 16.92 9.725 16.407C9.698 16.11 9.698 15.138 9.698 14.085V11.142C9.698 8.901 9.698 7.2 9.752 6.741C9.779 6.552 9.752 6.417 9.617 6.417C9.455 6.417 9.32 6.471 9.104 6.579C8.078 7.146 7.052 7.578 6.188 7.902C6.053 7.956 5.999 8.01 5.999 8.091V8.334C5.999 8.442 6.053 8.496 6.242 8.523C7.592 8.739 7.754 9.225 7.754 10.143V14.112ZM8.024 3.312C9.104 3.312 9.59 2.529 9.59 1.827C9.59 1.233 9.131 0.504 8.186 0.504C7.106 0.504 6.539 1.233 6.539 1.908C6.539 2.772 7.43 3.312 8.024 3.312Z",
    fill: "#626B77"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white"
  }))));
};

export default InfoIcon;